(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathfinder-free-lesson"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pf-free-lesson')) {
  customElements.define('pf-free-lesson', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-pff-open]');
        if (opener && this.contains(opener)) {
          const dialog = document.getElementById(opener.dataset.pffOpen);
          if (dialog && this.contains(dialog) && !dialog.open) {
            dialog.removeAttribute('data-zoom');
            dialog.querySelector('[data-pff-zoom]')?.setAttribute('aria-pressed', 'false');
            dialog.showModal();
          }
        }
        const zoom = event.target.closest('[data-pff-zoom]');
        if (zoom) {
          const dialog = zoom.closest('dialog');
          const active = dialog.toggleAttribute('data-zoom');
          zoom.setAttribute('aria-pressed', String(active));
          const scroll = dialog.querySelector('.pff-dialog-scroll');
          scroll.setAttribute('tabindex', '0');
          scroll.scrollTo(0, 0);
        }
        if (event.target.matches('dialog')) {
          const bounds = event.target.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathfinder-home-testimonials"] && !Shopify.designMode) return;
  try {
    
function initializePathfinderQuotes(root=document){root.querySelectorAll('[data-pf-quotes]').forEach(carousel=>{if(carousel.dataset.ready)return;carousel.dataset.ready='true';const slides=[...carousel.querySelectorAll('[data-pf-quote]')];const dots=[...carousel.querySelectorAll('[data-pf-quote-index]')];let current=0;const show=index=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==current);dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===current)))};carousel.querySelector('[data-pf-prev]').addEventListener('click',()=>show(current-1));carousel.querySelector('[data-pf-next]').addEventListener('click',()=>show(current+1));dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i)))})}initializePathfinderQuotes();document.addEventListener('shopify:section:load',()=>initializePathfinderQuotes());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathfinder-unit-environmental"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click",event=>{const trigger=event.target.closest("[data-pfe-open-contents]");if(trigger){const dialog=trigger.closest(".pfe").querySelector(".pfe-contents-dialog");dialog.showModal();dialog.addEventListener("close",()=>trigger.focus(),{once:true});}});
if (!customElements.get('pathfinder-environmental')) {
  customElements.define('pathfinder-environmental', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.pages = JSON.parse(this.querySelector('[data-pages]').textContent)[this.dataset.kind];
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.index = 0; this.zoom = false; this.rotated = false;
      this.dialog = this.querySelector('dialog');
      this.thumbs = this.querySelector('.ev-thumbs');
      this.thumbs.replaceChildren(...this.pages.map((page, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.page = i;
        button.setAttribute('aria-label', `${this.labels.page} ${i + 1}: ${page.title}`);
        const image = document.createElement('img'); image.src = page.src; image.alt = ''; image.loading = 'lazy';
        const label = document.createElement('span');
        const title = document.createElement('b'); title.textContent = page.title;
        const number = document.createElement('small'); number.textContent = `${this.labels.page} ${i + 1}`;
        label.append(title, number); button.append(image, label); return button;
      }));
      this.addEventListener('click', event => {
        const page = event.target.closest('[data-page]');
        if (page) { this.change(Number(page.dataset.page)); return; }
        const button = event.target.closest('[data-action]'); if (!button) return;
        switch (button.dataset.action) {
          case 'prev': this.change(this.index - 1); break;
          case 'next': this.change(this.index + 1); break;
          case 'zoom': this.zoom = !this.zoom; this.render(); break;
          case 'rotate': this.rotated = !this.rotated; this.render(); break;
          case 'fullscreen': this.dialog.showModal(); this.layout(); break;
          case 'close': this.dialog.close(); break;
        }
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.change(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.dialog.addEventListener('close', () => this.querySelector('[data-action=fullscreen]').focus(), {signal});
      this.observer = new ResizeObserver(() => this.layout());
      this.querySelectorAll('.ev-stage').forEach(stage => this.observer.observe(stage));
      this.dataset.ready = 'true'; this.render();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    change(index) {
      if (index < 0 || index >= this.pages.length) return;
      this.index = index; this.zoom = false; this.rotated = false; this.render();
    }
    render() {
      const page = this.pages[this.index];
      this.thumbs.querySelectorAll('button').forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
      this.querySelectorAll('.ev-paper').forEach(image => {
        image.src = page.src; image.alt = page.alt; image.width = page.width; image.height = page.height;
      });
      this.querySelectorAll('.ev-page-title').forEach(node => node.textContent = page.title);
      this.querySelectorAll('.ev-counter').forEach(node => node.textContent = `${this.labels.name} · ${this.index + 1} / ${this.pages.length}`);
      this.querySelectorAll('.ev-caption').forEach(node => node.textContent = page.caption);
      this.querySelectorAll('[data-action=prev]').forEach(button => button.disabled = this.index === 0);
      this.querySelectorAll('[data-action=next]').forEach(button => button.disabled = this.index === this.pages.length - 1);
      this.querySelectorAll('[data-action=zoom]').forEach(button => {
        button.textContent = this.zoom ? this.labels.fit : this.labels.zoom;
        button.setAttribute('aria-pressed', String(this.zoom));
      });
      this.querySelectorAll('[data-action=rotate]').forEach(button => {
        button.hidden = !page.sideways; button.textContent = this.rotated ? this.labels.restore : this.labels.rotate;
        button.setAttribute('aria-pressed', String(this.rotated));
      });
      this.querySelector('.ev-orientation-note').hidden = !page.sideways;
      this.querySelector('.ev-status').textContent = `${this.labels.name}, ${this.labels.page} ${this.index + 1} / ${this.pages.length}: ${page.title}`;
      this.layout();
      this.querySelectorAll('.ev-stage').forEach(stage => { stage.scrollTop = 0; stage.scrollLeft = 0; });
    }
    layout() {
      const page = this.pages[this.index]; if (!page) return;
      this.querySelectorAll('.ev-stage').forEach(stage => {
        if (!stage.clientWidth || !stage.clientHeight) return;
        const style = getComputedStyle(stage);
        const availableWidth = stage.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const availableHeight = stage.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
        const width = this.rotated ? page.height : page.width;
        const height = this.rotated ? page.width : page.height;
        const scale = Math.min(availableWidth / width, availableHeight / height) * (this.zoom ? 3 : 1);
        const sheet = stage.querySelector('.ev-sheet'), image = stage.querySelector('.ev-paper');
        sheet.style.width = `${width * scale}px`; sheet.style.height = `${height * scale}px`;
        image.style.width = `${page.width * scale}px`; image.style.height = `${page.height * scale}px`;
        image.style.transform = `translate(-50%, -50%) rotate(${this.rotated ? 90 : 0}deg)`;
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathfinder-unit-fire-cooking"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click",event=>{const trigger=event.target.closest("[data-pff-open-contents]");if(trigger){const dialog=trigger.closest(".pff").querySelector(".pff-contents-dialog");dialog.showModal();dialog.addEventListener("close",()=>trigger.focus(),{once:true});}});
if (!customElements.get('pathfinder-fire-cooking')) {
  customElements.define('pathfinder-fire-cooking', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.pages = JSON.parse(this.querySelector('[data-pages]').textContent)[this.dataset.kind];
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.index = 0; this.zoom = false; this.rotated = false;
      this.dialog = this.querySelector('dialog');
      this.thumbs = this.querySelector('.fv-thumbs');
      this.thumbs.replaceChildren(...this.pages.map((page, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.page = i;
        button.setAttribute('aria-label', `${this.labels.page} ${i + 1}: ${page.title}`);
        const image = document.createElement('img'); image.src = page.src; image.alt = ''; image.loading = 'lazy';
        const label = document.createElement('span');
        const title = document.createElement('b'); title.textContent = page.title;
        const number = document.createElement('small'); number.textContent = `${this.labels.page} ${i + 1}`;
        label.append(title, number); button.append(image, label); return button;
      }));
      this.addEventListener('click', event => {
        const page = event.target.closest('[data-page]');
        if (page) { this.change(Number(page.dataset.page)); return; }
        const button = event.target.closest('[data-action]'); if (!button) return;
        switch (button.dataset.action) {
          case 'prev': this.change(this.index - 1); break;
          case 'next': this.change(this.index + 1); break;
          case 'zoom': this.zoom = !this.zoom; this.render(); break;
          case 'rotate': this.rotated = !this.rotated; this.render(); break;
          case 'fullscreen': this.dialog.showModal(); this.layout(); break;
          case 'close': this.dialog.close(); break;
        }
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.change(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.dialog.addEventListener('close', () => this.querySelector('[data-action=fullscreen]').focus(), {signal});
      this.observer = new ResizeObserver(() => this.layout());
      this.querySelectorAll('.fv-stage').forEach(stage => this.observer.observe(stage));
      this.dataset.ready = 'true'; this.render();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    change(index) {
      if (index < 0 || index >= this.pages.length) return;
      this.index = index; this.zoom = false; this.rotated = false; this.render();
    }
    render() {
      const page = this.pages[this.index];
      this.thumbs.querySelectorAll('button').forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
      this.querySelectorAll('.fv-paper').forEach(image => {
        image.src = page.src; image.alt = page.alt; image.width = page.width; image.height = page.height;
      });
      this.querySelectorAll('.fv-page-title').forEach(node => node.textContent = page.title);
      this.querySelectorAll('.fv-counter').forEach(node => node.textContent = `${this.labels.name} · ${this.index + 1} / ${this.pages.length}`);
      this.querySelectorAll('.fv-caption').forEach(node => node.textContent = page.caption);
      this.querySelectorAll('[data-action=prev]').forEach(button => button.disabled = this.index === 0);
      this.querySelectorAll('[data-action=next]').forEach(button => button.disabled = this.index === this.pages.length - 1);
      this.querySelectorAll('[data-action=zoom]').forEach(button => {
        button.textContent = this.zoom ? this.labels.fit : this.labels.zoom;
        button.setAttribute('aria-pressed', String(this.zoom));
      });
      this.querySelectorAll('[data-action=rotate]').forEach(button => {
        button.hidden = !page.sideways; button.textContent = this.rotated ? this.labels.restore : this.labels.rotate;
        button.setAttribute('aria-pressed', String(this.rotated));
      });
      this.querySelector('.fv-orientation-note').hidden = !page.sideways;
      this.querySelector('.fv-status').textContent = `${this.labels.name}, ${this.labels.page} ${this.index + 1} / ${this.pages.length}: ${page.title}`;
      this.layout();
      this.querySelectorAll('.fv-stage').forEach(stage => { stage.scrollTop = 0; stage.scrollLeft = 0; });
    }
    layout() {
      const page = this.pages[this.index]; if (!page) return;
      this.querySelectorAll('.fv-stage').forEach(stage => {
        if (!stage.clientWidth || !stage.clientHeight) return;
        const style = getComputedStyle(stage);
        const availableWidth = stage.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const availableHeight = stage.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
        const width = this.rotated ? page.height : page.width;
        const height = this.rotated ? page.width : page.height;
        const scale = Math.min(availableWidth / width, availableHeight / height) * (this.zoom ? 3 : 1);
        const sheet = stage.querySelector('.fv-sheet'), image = stage.querySelector('.fv-paper');
        sheet.style.width = `${width * scale}px`; sheet.style.height = `${height * scale}px`;
        image.style.width = `${page.width * scale}px`; image.style.height = `${page.height * scale}px`;
        image.style.transform = `translate(-50%, -50%) rotate(${this.rotated ? 90 : 0}deg)`;
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathfinder-unit-first-aid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click",event=>{const trigger=event.target.closest("[data-pfa-open-contents]");if(trigger){const dialog=trigger.closest(".pfa").querySelector(".pfa-contents-dialog");dialog.showModal();dialog.addEventListener("close",()=>trigger.focus(),{once:true});}});
if (!customElements.get('pathfinder-first-aid')) {
  customElements.define('pathfinder-first-aid', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.pages = JSON.parse(this.querySelector('[data-pages]').textContent)[this.dataset.kind];
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.index = 0; this.zoom = false; this.rotated = false;
      this.dialog = this.querySelector('dialog');
      this.thumbs = this.querySelector('.av-thumbs');
      this.thumbs.replaceChildren(...this.pages.map((page, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.page = i;
        button.setAttribute('aria-label', `${this.labels.page} ${i + 1}: ${page.title}`);
        const image = document.createElement('img'); image.src = page.src; image.alt = ''; image.loading = 'lazy';
        const label = document.createElement('span');
        const title = document.createElement('b'); title.textContent = page.title;
        const number = document.createElement('small'); number.textContent = `${this.labels.page} ${i + 1}`;
        label.append(title, number); button.append(image, label); return button;
      }));
      this.addEventListener('click', event => {
        const page = event.target.closest('[data-page]');
        if (page) { this.change(Number(page.dataset.page)); return; }
        const button = event.target.closest('[data-action]'); if (!button) return;
        switch (button.dataset.action) {
          case 'prev': this.change(this.index - 1); break;
          case 'next': this.change(this.index + 1); break;
          case 'zoom': this.zoom = !this.zoom; this.render(); break;
          case 'rotate': this.rotated = !this.rotated; this.render(); break;
          case 'fullscreen': this.dialog.showModal(); this.layout(); break;
          case 'close': this.dialog.close(); break;
        }
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.change(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.dialog.addEventListener('close', () => this.querySelector('[data-action=fullscreen]').focus(), {signal});
      this.observer = new ResizeObserver(() => this.layout());
      this.querySelectorAll('.av-stage').forEach(stage => this.observer.observe(stage));
      this.dataset.ready = 'true'; this.render();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    change(index) {
      if (index < 0 || index >= this.pages.length) return;
      this.index = index; this.zoom = false; this.rotated = false; this.render();
    }
    render() {
      const page = this.pages[this.index];
      this.thumbs.querySelectorAll('button').forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
      this.querySelectorAll('.av-paper').forEach(image => {
        image.src = page.src; image.alt = page.alt; image.width = page.width; image.height = page.height;
      });
      this.querySelectorAll('.av-page-title').forEach(node => node.textContent = page.title);
      this.querySelectorAll('.av-counter').forEach(node => node.textContent = `${this.labels.name} · ${this.index + 1} / ${this.pages.length}`);
      this.querySelectorAll('.av-caption').forEach(node => node.textContent = page.caption);
      this.querySelectorAll('[data-action=prev]').forEach(button => button.disabled = this.index === 0);
      this.querySelectorAll('[data-action=next]').forEach(button => button.disabled = this.index === this.pages.length - 1);
      this.querySelectorAll('[data-action=zoom]').forEach(button => {
        button.textContent = this.zoom ? this.labels.fit : this.labels.zoom;
        button.setAttribute('aria-pressed', String(this.zoom));
      });
      this.querySelectorAll('[data-action=rotate]').forEach(button => {
        button.hidden = !page.sideways; button.textContent = this.rotated ? this.labels.restore : this.labels.rotate;
        button.setAttribute('aria-pressed', String(this.rotated));
      });
      this.querySelector('.av-orientation-note').hidden = !page.sideways;
      this.querySelector('.av-status').textContent = `${this.labels.name}, ${this.labels.page} ${this.index + 1} / ${this.pages.length}: ${page.title}`;
      this.layout();
      this.querySelectorAll('.av-stage').forEach(stage => { stage.scrollTop = 0; stage.scrollLeft = 0; });
    }
    layout() {
      const page = this.pages[this.index]; if (!page) return;
      this.querySelectorAll('.av-stage').forEach(stage => {
        if (!stage.clientWidth || !stage.clientHeight) return;
        const style = getComputedStyle(stage);
        const availableWidth = stage.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const availableHeight = stage.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
        const width = this.rotated ? page.height : page.width;
        const height = this.rotated ? page.width : page.height;
        const scale = Math.min(availableWidth / width, availableHeight / height) * (this.zoom ? 3 : 1);
        const sheet = stage.querySelector('.av-sheet'), image = stage.querySelector('.av-paper');
        sheet.style.width = `${width * scale}px`; sheet.style.height = `${height * scale}px`;
        image.style.width = `${page.width * scale}px`; image.style.height = `${page.height * scale}px`;
        image.style.transform = `translate(-50%, -50%) rotate(${this.rotated ? 90 : 0}deg)`;
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathfinder-unit-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click",event=>{const trigger=event.target.closest("[data-pfn-open-contents]");if(trigger){const dialog=trigger.closest(".pfn").querySelector(".pfn-contents-dialog");dialog.showModal();dialog.addEventListener("close",()=>trigger.focus(),{once:true});}});
if (!customElements.get('pathfinder-navigation')) {
  customElements.define('pathfinder-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.pages = JSON.parse(this.querySelector('[data-pages]').textContent)[this.dataset.kind];
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.index = 0; this.zoom = false; this.rotated = false;
      this.dialog = this.querySelector('dialog');
      this.thumbs = this.querySelector('.nv-thumbs');
      this.thumbs.replaceChildren(...this.pages.map((page, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.page = i;
        button.setAttribute('aria-label', `${this.labels.page} ${i + 1}: ${page.title}`);
        const image = document.createElement('img'); image.src = page.src; image.alt = ''; image.loading = 'lazy';
        const label = document.createElement('span');
        const title = document.createElement('b'); title.textContent = page.title;
        const number = document.createElement('small'); number.textContent = `${this.labels.page} ${i + 1}`;
        label.append(title, number); button.append(image, label); return button;
      }));
      this.addEventListener('click', event => {
        const page = event.target.closest('[data-page]');
        if (page) { this.change(Number(page.dataset.page)); return; }
        const button = event.target.closest('[data-action]'); if (!button) return;
        switch (button.dataset.action) {
          case 'prev': this.change(this.index - 1); break;
          case 'next': this.change(this.index + 1); break;
          case 'zoom': this.zoom = !this.zoom; this.render(); break;
          case 'rotate': this.rotated = !this.rotated; this.render(); break;
          case 'fullscreen': this.dialog.showModal(); this.layout(); break;
          case 'close': this.dialog.close(); break;
        }
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.change(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.dialog.addEventListener('close', () => this.querySelector('[data-action=fullscreen]').focus(), {signal});
      this.observer = new ResizeObserver(() => this.layout());
      this.querySelectorAll('.nv-stage').forEach(stage => this.observer.observe(stage));
      this.dataset.ready = 'true'; this.render();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    change(index) {
      if (index < 0 || index >= this.pages.length) return;
      this.index = index; this.zoom = false; this.rotated = false; this.render();
    }
    render() {
      const page = this.pages[this.index];
      this.thumbs.querySelectorAll('button').forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
      this.querySelectorAll('.nv-paper').forEach(image => {
        image.src = page.src; image.alt = page.alt; image.width = page.width; image.height = page.height;
      });
      this.querySelectorAll('.nv-page-title').forEach(node => node.textContent = page.title);
      this.querySelectorAll('.nv-counter').forEach(node => node.textContent = `${this.labels.name} · ${this.index + 1} / ${this.pages.length}`);
      this.querySelectorAll('.nv-caption').forEach(node => node.textContent = page.caption);
      this.querySelectorAll('[data-action=prev]').forEach(button => button.disabled = this.index === 0);
      this.querySelectorAll('[data-action=next]').forEach(button => button.disabled = this.index === this.pages.length - 1);
      this.querySelectorAll('[data-action=zoom]').forEach(button => {
        button.textContent = this.zoom ? this.labels.fit : this.labels.zoom;
        button.setAttribute('aria-pressed', String(this.zoom));
      });
      this.querySelectorAll('[data-action=rotate]').forEach(button => {
        button.hidden = !page.sideways; button.textContent = this.rotated ? this.labels.restore : this.labels.rotate;
        button.setAttribute('aria-pressed', String(this.rotated));
      });
      this.querySelector('.nv-orientation-note').hidden = !page.sideways;
      this.querySelector('.nv-status').textContent = `${this.labels.name}, ${this.labels.page} ${this.index + 1} / ${this.pages.length}: ${page.title}`;
      this.layout();
      this.querySelectorAll('.nv-stage').forEach(stage => { stage.scrollTop = 0; stage.scrollLeft = 0; });
    }
    layout() {
      const page = this.pages[this.index]; if (!page) return;
      this.querySelectorAll('.nv-stage').forEach(stage => {
        if (!stage.clientWidth || !stage.clientHeight) return;
        const style = getComputedStyle(stage);
        const availableWidth = stage.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const availableHeight = stage.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
        const width = this.rotated ? page.height : page.width;
        const height = this.rotated ? page.width : page.height;
        const scale = Math.min(availableWidth / width, availableHeight / height) * (this.zoom ? 3 : 1);
        const sheet = stage.querySelector('.nv-sheet'), image = stage.querySelector('.nv-paper');
        sheet.style.width = `${width * scale}px`; sheet.style.height = `${height * scale}px`;
        image.style.width = `${page.width * scale}px`; image.style.height = `${page.height * scale}px`;
        image.style.transform = `translate(-50%, -50%) rotate(${this.rotated ? 90 : 0}deg)`;
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathfinder-unit-shelters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click",event=>{const trigger=event.target.closest("[data-pfu-open-contents]");if(trigger){const dialog=trigger.closest(".pfu").querySelector(".pfu-contents-dialog");dialog.showModal();dialog.addEventListener("close",()=>trigger.focus(),{once:true});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathfinder-unit-tools"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click",event=>{const trigger=event.target.closest("[data-pft-open-contents]");if(trigger){const dialog=trigger.closest(".pft").querySelector(".pft-contents-dialog");dialog.showModal();dialog.addEventListener("close",()=>trigger.focus(),{once:true});}});
if (!customElements.get('pathfinder-tools')) {
  customElements.define('pathfinder-tools', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.pages = JSON.parse(this.querySelector('[data-pages]').textContent)[this.dataset.kind];
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.index = 0; this.zoom = false; this.rotated = false;
      this.dialog = this.querySelector('dialog');
      this.thumbs = this.querySelector('.tv-thumbs');
      this.thumbs.replaceChildren(...this.pages.map((page, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.page = i;
        button.setAttribute('aria-label', `${this.labels.page} ${i + 1}: ${page.title}`);
        const image = document.createElement('img'); image.src = page.src; image.alt = ''; image.loading = 'lazy';
        const label = document.createElement('span');
        const title = document.createElement('b'); title.textContent = page.title;
        const number = document.createElement('small'); number.textContent = `${this.labels.page} ${i + 1}`;
        label.append(title, number); button.append(image, label); return button;
      }));
      this.addEventListener('click', event => {
        const page = event.target.closest('[data-page]');
        if (page) { this.change(Number(page.dataset.page)); return; }
        const button = event.target.closest('[data-action]'); if (!button) return;
        switch (button.dataset.action) {
          case 'prev': this.change(this.index - 1); break;
          case 'next': this.change(this.index + 1); break;
          case 'zoom': this.zoom = !this.zoom; this.render(); break;
          case 'rotate': this.rotated = !this.rotated; this.render(); break;
          case 'fullscreen': this.dialog.showModal(); this.layout(); break;
          case 'close': this.dialog.close(); break;
        }
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.change(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.dialog.addEventListener('close', () => this.querySelector('[data-action=fullscreen]').focus(), {signal});
      this.observer = new ResizeObserver(() => this.layout());
      this.querySelectorAll('.tv-stage').forEach(stage => this.observer.observe(stage));
      this.dataset.ready = 'true'; this.render();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    change(index) {
      if (index < 0 || index >= this.pages.length) return;
      this.index = index; this.zoom = false; this.rotated = false; this.render();
    }
    render() {
      const page = this.pages[this.index];
      this.thumbs.querySelectorAll('button').forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
      this.querySelectorAll('.tv-paper').forEach(image => {
        image.src = page.src; image.alt = page.alt; image.width = page.width; image.height = page.height;
      });
      this.querySelectorAll('.tv-page-title').forEach(node => node.textContent = page.title);
      this.querySelectorAll('.tv-counter').forEach(node => node.textContent = `${this.labels.name} · ${this.index + 1} / ${this.pages.length}`);
      this.querySelectorAll('.tv-caption').forEach(node => node.textContent = page.caption);
      this.querySelectorAll('[data-action=prev]').forEach(button => button.disabled = this.index === 0);
      this.querySelectorAll('[data-action=next]').forEach(button => button.disabled = this.index === this.pages.length - 1);
      this.querySelectorAll('[data-action=zoom]').forEach(button => {
        button.textContent = this.zoom ? this.labels.fit : this.labels.zoom;
        button.setAttribute('aria-pressed', String(this.zoom));
      });
      this.querySelectorAll('[data-action=rotate]').forEach(button => {
        button.hidden = !page.sideways; button.textContent = this.rotated ? this.labels.restore : this.labels.rotate;
        button.setAttribute('aria-pressed', String(this.rotated));
      });
      this.querySelector('.tv-orientation-note').hidden = !page.sideways;
      this.querySelector('.tv-status').textContent = `${this.labels.name}, ${this.labels.page} ${this.index + 1} / ${this.pages.length}: ${page.title}`;
      this.layout();
      this.querySelectorAll('.tv-stage').forEach(stage => { stage.scrollTop = 0; stage.scrollLeft = 0; });
    }
    layout() {
      const page = this.pages[this.index]; if (!page) return;
      this.querySelectorAll('.tv-stage').forEach(stage => {
        if (!stage.clientWidth || !stage.clientHeight) return;
        const style = getComputedStyle(stage);
        const availableWidth = stage.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const availableHeight = stage.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
        const width = this.rotated ? page.height : page.width;
        const height = this.rotated ? page.width : page.height;
        const scale = Math.min(availableWidth / width, availableHeight / height) * (this.zoom ? 3 : 1);
        const sheet = stage.querySelector('.tv-sheet'), image = stage.querySelector('.tv-paper');
        sheet.style.width = `${width * scale}px`; sheet.style.height = `${height * scale}px`;
        image.style.width = `${page.width * scale}px`; image.style.height = `${page.height * scale}px`;
        image.style.transform = `translate(-50%, -50%) rotate(${this.rotated ? 90 : 0}deg)`;
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
